import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=74e4dc71&scoped=true&"
import script from "./IconSelector.vue?vue&type=script&lang=js&"
export * from "./IconSelector.vue?vue&type=script&lang=js&"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=74e4dc71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e4dc71",
  null
  
)

export default component.exports